import { createTrackingUtils } from "..";
import { UIFlightData } from "@flights/types";
import useProfiler from "../../../hooks/useProfiler";

const expConfig = {
  stages: {
    main: 1,
    direct: 2,
    meta: 3,
    topFiveTheSame: 4,
    topFiveTheSameDirect: 5,
    topFiveTheSameMeta: 6,
    firstPageTheSame: 7,
    firstPageTheSameDirect: 8,
    firstPageTheSameMeta: 9
  },
  goals: {
    topFiveClick: 1,
    topFiveClickAndPay: 2,
    firstPageClick: 3,
    firstPageClickAndPay: 4
  }
};

const desktop = createTrackingUtils({
  ...expConfig,
  name: "flights_web_aa_lack_of_choice_ddot",
  defaultStage: 1
});

const mDot = createTrackingUtils({
  ...expConfig,
  name: "flights_web_aa_lack_of_choice_mdot",
  defaultStage: 1
});

const getExp = (isMobile: boolean) => {
  return isMobile ? mDot : desktop;
};

const useTrackStages = (flightOffers: UIFlightData[]) => {
  const { isMobile, isDirect } = useProfiler();
  const { stages } = getExp(isMobile());

  const querySrPage = new URLSearchParams(location.search).get("page");
  const isFirstSrPage = !querySrPage || Number(querySrPage) === 1;
  if (!isFirstSrPage) {
    return;
  }

  stages.main();
  isDirect() ? stages.direct() : stages.meta();

  if (isTheSameAirline(flightOffers.slice(0, 5))) {
    stages.topFiveTheSame();
    isDirect() ? stages.topFiveTheSameDirect() : stages.topFiveTheSameMeta();
  }
  if (isTheSameAirline(flightOffers)) {
    stages.firstPageTheSame();
    isDirect() ? stages.firstPageTheSameDirect() : stages.firstPageTheSameMeta();
  }
};

const isTheSameAirline = (flightOffers: UIFlightData[]): boolean => {
  const firstCarrierCode = flightOffers[0]?.segments[0]?.legs[0]?.carriersData[0]?.code;

  const same = flightOffers.every(({ segments }) => {
    return segments.every(({ legs }) => {
      return legs.every(({ carriersData }) => {
        return carriersData[0]?.code === firstCarrierCode;
      });
    });
  });

  return same;
};

export default { getExp, useTrackStages };
